import { useCallback, useMemo } from "react"
import useRequest from "./useRequest"
import { API_USER, BASE_ADMIN } from "../constants/api";
import { UserDBType } from "../types/user";
import { RequestError } from "../errors/RequestError";

const useProfileById = () => {
  const {request, response, error, isLoading} = useRequest<{user: UserDBType & { accountActivateAt: string | null }}>();

  const profileNotFound = useMemo(() => error instanceof RequestError && error.status === 404, [error]);

  const getProfileById = useCallback((id: number) => {
    request(BASE_ADMIN, `${API_USER}/${id}`, {secure: true});
  }, [request])

  return {
    getProfileById, profile: response?.user || null, error, isLoading, profileNotFound
  }
}

export default useProfileById;